import { Routes } from '@angular/router';
import { NotFoundComponent } from 'src/shared/components/notfound/notfound.component';
import { MAINTENANCE_WINDOW_PATH } from 'src/shared/constants/maintenance-window.constants';
import { LoginGuard } from 'src/shared/guards/login.guard';
import { maintenanceGuard } from 'src/shared/guards/maintenance-window.guard';
import { MANUAL_APP_UPDATE_ROUTE_DATA } from 'src/shared/service-worker/app-update.service';
import { PageWrapperComponent } from './components/page-wrapper/page-wrapper.component';
import { TrialsAuthenticatedContainerComponent } from './components/trials-authenticated-container/trials-authenticated-container.component';

export const trialsRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((x) => x.LoginComponent),
    canActivate: [maintenanceGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('src/shared/components/authentication/trials-login/trials-login.component').then(
            (x) => x.TrialsLoginComponent
          ),
      },
    ],
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./pages/onboarding/onboarding.component').then((x) => x.OnboardingComponent),
    canActivate: [maintenanceGuard],
    data: MANUAL_APP_UPDATE_ROUTE_DATA,
  },
  {
    path: 'onboarding/:step',
    loadComponent: () => import('./pages/onboarding/onboarding.component').then((x) => x.OnboardingComponent),
    canActivate: [maintenanceGuard],
    data: MANUAL_APP_UPDATE_ROUTE_DATA,
  },
  {
    path: 'screening-form/:trial_id',
    loadComponent: () =>
      import('./pages/screening-form/screening-form.component').then((x) => x.ScreeningFormComponent),
    canActivate: [maintenanceGuard, LoginGuard],
    data: MANUAL_APP_UPDATE_ROUTE_DATA,
  },
  {
    path: '',
    // Eager layout: lazy-loading this shell was recreating header/footer on every child navigation.
    component: TrialsAuthenticatedContainerComponent,
    canActivate: [LoginGuard],
    canActivateChild: [maintenanceGuard],
    children: [
      {
        path: '',
        component: PageWrapperComponent,
        children: [
          { path: '', redirectTo: 'home', pathMatch: 'full' },
          {
            path: 'home',
            loadComponent: () => import('./pages/home/home.component').then((x) => x.HomeComponent),
          },
          {
            path: 'trial/:trial_doc_id',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./pages/trial-dashboard/trial-dashboard.component').then((x) => x.TrialDashboardComponent),
              },
              {
                path: 'call/:step_doc_id',
                loadComponent: () => import('./pages/call/call.component').then((x) => x.CallComponent),
                data: MANUAL_APP_UPDATE_ROUTE_DATA,
              },
              {
                path: 'appointment/:appointment_doc_id',
                loadComponent: () => import('./pages/call/call.component').then((x) => x.CallComponent),
                data: MANUAL_APP_UPDATE_ROUTE_DATA,
              },
              {
                path: 'book-consultation',
                loadComponent: () =>
                  import('./pages/book-consultation/book-consultation.component').then(
                    (x) => x.BookConsultationComponent
                  ),
                data: MANUAL_APP_UPDATE_ROUTE_DATA,
              },
              {
                path: 'report-issue',
                data: MANUAL_APP_UPDATE_ROUTE_DATA,
                children: [
                  {
                    path: 'success',
                    loadComponent: () =>
                      import('src/shared/components/report-an-issue-success/report-an-issue-success.component').then(
                        (x) => x.ReportAnIssueSuccessComponent
                      ),
                  },
                  {
                    path: '',
                    loadComponent: () =>
                      import('src/shared/components/report-an-issue-participant/report-an-issue-participant.component').then(
                        (x) => x.ReportAnIssueParticipantComponent
                      ),
                  },
                  {
                    path: ':issue',
                    loadComponent: () =>
                      import('src/shared/components/report-an-issue-participant/report-an-issue-participant.component').then(
                        (x) => x.ReportAnIssueParticipantComponent
                      ),
                  },
                ],
              },
              {
                path: 'chatcall/:chatId/:callId',
                loadComponent: () =>
                  import('./components/chat/pages/chat-call-page.component').then((x) => x.ChatCallPageComponent),
                data: MANUAL_APP_UPDATE_ROUTE_DATA,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./pages/verify-email/verify-email.component').then((x) => x.VerifyEmailComponent),
    canActivate: [maintenanceGuard],
  },
  {
    path: MAINTENANCE_WINDOW_PATH,
    loadComponent: () =>
      import('src/shared/components/maintenance-window/maintenance-window-page/maintenance-window-page.component').then(
        (x) => x.MaintenanceWindowPageComponent
      ),
    title: 'Under Maintenance',
  },
  {
    path: 'notfound',
    component: NotFoundComponent,
    canActivate: [maintenanceGuard],
    title: 'Trials - Page Not Found',
  },
  { path: '**', redirectTo: 'notfound' },
];
